const INITIAL_CONTEXT = {
  error: false,
  fetching: false,
  setError: (): null => null,
  setFetching: (): null => null,
};

export { INITIAL_CONTEXT };
